import React from 'react'
import Cookies from 'js-cookie'
import { Modal } from 'msp-components'
import AgentIdForm from './AgentIdForm'
import { AGENT_COOKIE_NAME } from '@/constants'
import { agentModal } from './PosStart.styles'

const AgentIdModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean
  onClose: () => void
}) => {
  const [agentId, setAgentId] = React.useState<string>(
    Cookies.get(AGENT_COOKIE_NAME) || ''
  )

  const saveAgentId = (data: { agentId: string }): void => {
    if (data.agentId && data.agentId.trim().length !== 0) {
      Cookies.set(AGENT_COOKIE_NAME, data.agentId, { expires: 365 })
    } else {
      Cookies.remove(AGENT_COOKIE_NAME)
    }
    setAgentId(data.agentId)
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      style={agentModal}
      modalBody={<AgentIdForm onSubmit={saveAgentId} initialValue={agentId} />}
      hideCloseButton
      overlay
      blockScroll
    />
  )
}

export default AgentIdModal
